module.exports = __webpack_public_path__ + "img/userLogo22.7b50127c.jpg";